import { Profile } from '../common/Profile'
import { formatProfileFirstLastName } from './profileFirstLastName'

export function formatProfileOrNullFirstLastName(profile: Profile | null) {
  if (profile === null) {
    return ''
  }
  return formatProfileFirstLastName(profile)
}